import React, { memo } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { Grid, MyModal, Button } from "views/utilities/MyCustomFile"
import ImportDynamicColumnKey from './ImportDynamicColumnKey';
import { Card } from '@mui/material';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    padding: 1 * 0.7,
    margin: `0 0 1px 0`,
    background: isDragging ? "lightgreen" : "darkcyan",
    color: "#fff",
    ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "burlywood",
    padding: "inherit",
    border: "1px solid #ed7da2"
});

const DragDropCommon = ({ isModalOpen, setItems, onHide, targetColumns, unmatchedColumns, setUnmatchedColumns, oldDataArr }) => {
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedItems = reorder(
            unmatchedColumns,
            result.source.index,
            result.destination.index
        );
        setUnmatchedColumns(reorderedItems);
    };

    const handleChangePage = (e) => {
        e.preventDefault()
        const updatedData = ImportDynamicColumnKey(oldDataArr, unmatchedColumns, targetColumns);
        setItems(updatedData)
        onHide()
    }

    return (<MyModal handleOpen={isModalOpen} handleClose={onHide} title={"Unmatched Columns"} size={'md'} cancelReset={true} modalStyle rows={<Grid container spacing={1}>
        <Grid item md={6}>
            <p>Static Columns</p>
            {targetColumns?.map((val, i) => <div key={i} style={{ padding: 'inherit', backgroundColor: "palegreen", border: "1px solid palevioletred", margin: '0 0 1px 0' }}>{val}</div>)}
        </Grid>
        <Grid item md={6}>
            <p>Import Columns</p>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {unmatchedColumns?.filter(e => e != "__EMPTY").map((item, index) => {
                                return (
                                    <Draggable key={item} draggableId={item} index={index}>
                                        {(provided, snapshot) => (
                                            <Card
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                sx={{
                                                    marginBottom: 2, // Spacing between cards
                                                    padding: 2, // Inner padding for card content
                                                    marginLeft: 1, // Left margin
                                                    display: 'flex', // Flex layout for content alignment
                                                    alignItems: 'center',
                                                    backgroundColor: snapshot.isDragging ? 'lightblue' : 'white',
                                                    ...getItemStyle(snapshot.isDragging, provided.draggableProps.style),
                                                }}
                                                style={{ marginLeft: 5, marginRight: 10 }}
                                            >
                                                <span>{item}</span>
                                            </Card>
                                        )}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </Grid>
    </Grid>} Save={<Button variant='outlined' onClick={handleChangePage}>Update Columns</Button>} />)
}
export default memo(DragDropCommon);